import React from 'react'

const UsersAppNew = () => {
  return <div></div>
}

export default UsersAppNew
